"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["active", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].span.withConfig({
  displayName: "spinner__Wrapper",
  componentId: "sc-nyc9bi-0"
})(["display:block;transform:scale(0.5);transition:transform ", ";", ""], (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('active', (0, _styledComponents.css)(["transform:scale(1);"])));
/**
 * `Loader` styled component.
 */


var Loader = _styledComponents["default"].span.withConfig({
  displayName: "spinner__Loader",
  componentId: "sc-nyc9bi-1"
})(["animation:", " 0.75s linear infinite;border-left-color:transparent;border-radius:", "px;border-style:solid;border-width:", "px;display:block;height:", "px;width:", "px;"], (0, _styledTools.theme)('keyframes.spin'), (0, _styledTools.prop)('size'), (0, _styledTools.prop)('stroke'), (0, _styledTools.prop)('size'), (0, _styledTools.prop)('size'));
/**
 * `Spinner` component.
 */


var Spinner = function Spinner(_ref) {
  var active = _ref.active,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    active: active,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Loader, rest));
};
/**
 * Default props.
 */


Spinner.defaultProps = {
  size: 24,
  stroke: 2
};
/**
 * Export `Spinner` component.
 */

var _default = Spinner;
exports["default"] = _default;